import type { ReactElement } from 'react';
import { useState } from 'react';

import { ApiRoute } from 'config';
import { del } from 'utils/network';

import { Component as CloseIcon } from 'icons/icon-ui--close-rounded.svg';

type Props = {
  id: number,
  theme: string,
  children: ReactElement,
  onClose?: () => void,
};

function PromoBanner({ id, theme, children, onClose }: Props): ReactElement | null {
  const [isClosed, setIsClosed] = useState(false);
  const onBannerClose = () => {
    setIsClosed(true);
    del(`${ApiRoute.NOTIFICATIONS}/${id}`);
    if (onClose) {
      onClose();
    }
  };

  if (isClosed) return null;

  return (
    <div className="c-promo-banner__wrapper">
      <div className={`c-promo-banner c-promo-banner--${theme}`}>
        <button
          className="c-promo-banner__close c-link"
          type="button"
          aria-label="Close promotional banner"
          onClick={onBannerClose}
        >
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>
  );
}

export default PromoBanner;
